import '@firebase/firestore-compat';
//# sourceMappingURL=index.esm.js.map
